import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {RequestBody} from '../../entity/core/request-body';
import {TitleSummaryTemplate} from '../../entity/model/title-summary-template';

export default class TitleSummaryTemplateAgent {

  getTitleSummaryTemplates = async (organizationId: string): Promise<TitleSummaryTemplate[]> => {
    return await API.get(awsApiName, `/organizations/${organizationId}/title-summary-templates`, {});
  }

  createTitleSummaryTemplate = async (organizationId: string, requestBody: RequestBody): Promise<TitleSummaryTemplate> => {
    return await API.post(awsApiName, `/organizations/${organizationId}/title-summary-templates`, requestBody);
  }
} 